import React from 'react';

import PropTypes from 'prop-types';

import {
    VERTICAL_OFFSET,
} from '../constants';

import styles from './ColumnChart.scss';

const propTypes = {
    columnWidth: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    onHover: PropTypes.func,
};
const defaultProps = {
    onHover() {},
};

function ColumnChart(props) {
    const {
        columnWidth,
        data,
        height,
        onHover,
    } = props;

    return (
        <svg>
            {Object.values(data).map((point, index) => {
                const {
                    xVal,
                    xCoord: x,
                    yCoord: y,
                    yVal,
                } = point;

                const tooltip = {
                    xPos: x,
                    xVal,
                    yPos: y,
                    yVal,
                };

                return (
                    <rect
                        className={styles.column}
                        height={height - y + VERTICAL_OFFSET}
                        key={`${index}-${x}-${y}`}
                        onMouseOut={() => onHover(false, {})}
                        onMouseOver={() => onHover(true, tooltip)}
                        onTouchEnd={() => onHover(false, {})}
                        onTouchStart={() => onHover(true, tooltip)}
                        width={columnWidth}
                        x={x}
                        y={y}
                    />
                );
            })}
        </svg>
    );
}

ColumnChart.propTypes = propTypes;
ColumnChart.defaultProps = defaultProps;

export default ColumnChart;
